"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CultureInfoEnAU = (function () {
    function CultureInfoEnAU() {
    }
    CultureInfoEnAU.prototype.financialYear = function (date) {
        if ((date.getMonth() + 1) < 7) {
            return date.getFullYear() - 1;
        }
        else {
            return date.getFullYear();
        }
    };
    CultureInfoEnAU.prototype.getLanguage = function () {
        return "en";
    };
    CultureInfoEnAU.prototype.getCountry = function () {
        return "AU";
    };
    return CultureInfoEnAU;
}());
exports.CultureInfoEnAU = CultureInfoEnAU;
//# sourceMappingURL=CultureInfo_enAU.js.map